export enum TagTypeEnum {
  activitySubtype = 'activity_subtype',
}
